import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter} from '@angular/material/core';
import { MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {AuthService} from '../../../services/auth.service';
import {Member} from '../../../models/member';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import {Category} from 'src/app/models/category';
import {Subscription} from 'rxjs';
import {CategoryService} from 'src/app/services/category.service';
import {Subcategory} from 'src/app/models/subcategory';
import {SubcategoryService} from 'src/app/services/subcategory.service';
import {Gn1Service} from 'src/app/services/gn1.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-member-viewer-dialog',
  templateUrl: './member-viewer-dialog.component.html',
  styleUrls: ['./member-viewer-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: []
})
export class MemberViewerDialogComponent implements OnInit {

  public maskPhone: string = "(00) 00000-0009"

  public Editor = ClassicEditor;

  public memberForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;

  public categories: Category[] = [];
  public subscriptionCategory: Subscription;

  public subCategories: Subcategory[] = [];
  public subscriptionSubCategory: Subscription;

  public situations: any[] = []

  public agenda: any = {'days': []}
  public local_title: any;

  public displayedOrdersByMembrColumns: string[] = [ 'name' ];

  public subCategorySelected_id: string;
  public subCategorySelected: Subcategory;

  public partnerText: string;

  public oldCategory: any = {};

  public enrolmentDataSource: MatTableDataSource<any>
  public displayedEnrolmentColumns: string[] = [ 'event', 'request' ];

  public selectedDocFile: any = null;

  constructor (
    private fb: FormBuilder,
    public _gn1Service: Gn1Service,
    private _categoryService: CategoryService,
    public _subcategoryService: SubcategoryService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Member
  ) {

    this.categories = this.loadCategories();
  }

  ngOnInit () {

    this.situations.push({name: "Quite", value: "0"})
    this.situations.push({name: "Não-Quite", value: "1"})
    this.situations.push({name: "Isento", value: "2"})

    this._adapter.setLocale('pt');

    // check is is insert or update
    this.isEdit = this.data.id != "0"

    if (this.isEdit) {
      this.local_title = this.data.name
    } else {
      this.local_title = "Associado"
    }

    // create user form
    this.memberForm = this.createForm()

    // populate the form
    this.setFormValues(this.data, this.memberForm)

    this.subCategories = this.loadSubCategories();

  }


  loadCategories (): any {

    this.subscriptionCategory = this._categoryService.select()
      .subscribe((result) => {

        this.categories = result.map(item => {
          let entity = new Category();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          return entity;
        });

        this.oldCategory = this.categories.find((e) => {
          return e.id == this.data.category
        })

      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Categorias Acesso negado", '', 'error');
        })

  }

  loadSubCategories (): any {

    this.subscriptionSubCategory = this._subcategoryService.select()
      .subscribe((result) => {

        this.subCategories = result.map(item => {
          let entity = new Subcategory();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.hidden = item.payload.doc.data().hidden;
          entity.partner = item.payload.doc.data().partner;
          return entity;
        });

      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Subcategorias Acesso negado", '', 'error');
        })

  }

  setFormValues (data, form) {

    let dtCreated
    if (data.created) {
      dtCreated = new Date(data.created.seconds * 1000)
    }
    form.controls.dateCreated.setValue(dtCreated);

    let dtBirth
    if (data.dateBirth) {
      dtBirth = new Date(data.dateBirth.seconds * 1000)
    }
    form.controls.dateBirth.setValue(dtBirth);

    let dtFiliation
    if (data.dateFiliation) {
      dtFiliation = new Date(data.dateFiliation.seconds * 1000)
    }
    form.controls.dateFiliation.setValue(dtFiliation);

    let dtTitulo
    if (data.dateTitle) {
      dtTitulo = new Date(data.dateTitle.seconds * 1000)
    }
    form.controls.dateTitle.setValue(dtTitulo);

    // this.maskPhone = ''
    form.controls.id.setValue(data.id);
    form.controls.category.setValue(data.category ? data.category : "");

    if (data.subCategory) {
      this.subCategorySelected = data.subCategory
      this.subCategorySelected_id = data.subCategory.id
      if (data.subCategory.partner) {
        this.partnerText = "Sócio"
      } else {
        this.partnerText = "Não Sócio"
      }
    }

    form.controls.situation.setValue(data.situation ? data.situation : "");
    form.controls.balance.setValue(data.balance ? data.balance : 0);
     form.controls.credit.setValue(data.credit ? data.credit : 0);
    form.controls.name.setValue(data.name ? data.name : "");

    form.controls.address.setValue(data.address ? data.address : "");
    form.controls.number.setValue(data.number ? data.number : "");
    form.controls.complement.setValue(data.complement ? data.complement : "");
    form.controls.postalCode.setValue(data.postalCode ? data.postalCode : "");

    form.controls.city.setValue(data.city ? data.city : "");
    form.controls.state.setValue(data.state ? data.state : "");
    form.controls.country.setValue(data.country ? data.country : "");
    form.controls.email.setValue(data.email ? data.email : "");

    form.controls.email2.setValue(data.email2 ? data.email2 : "");
    form.controls.cellPhone.setValue(data.cellPhone ? data.cellPhone : "");
    form.controls.cellPhonePrefix.setValue(data.cellPhonePrefix ? data.cellPhonePrefix : "+55");
    form.controls.faxPhone.setValue(data.faxPhone ? data.faxPhone : "");

    form.controls.image.setValue(data.image ? data.image : "");
    form.controls.text.setValue(data.text ? data.text : "");

    if (data.faxPhone && data.faxPhone.length > 10) {
      //    this.maskPhone = '(00) 0000-0000'
    } else {
      //   this.maskPhone = '(00) 00000-0000'
    }

    form.controls.clinicPhone.setValue(data.clinicPhone ? data.clinicPhone : "");
    form.controls.hospitalPhone.setValue(data.hospitalPhone ? data.hospitalPhone : "");
    form.controls.aux1Phone.setValue(data.aux1Phone ? data.aux1Phone : "");
    form.controls.aux2Phone.setValue(data.aux2Phone ? data.aux2Phone : "");

    form.controls.rg.setValue(data.rg ? data.rg : "");

    form.controls.cpf.setValue(data.cpf ? data.cpf : "");
    form.controls.crm.setValue(data.crm ? data.crm : "");
    form.controls.regional.setValue(data.regional ? data.regional : "");
    form.controls.sex.setValue(data.sex ? data.sex : "");
    form.controls.obs.setValue(data.obs ? data.obs : "");
    form.controls.staff.setValue(data.staff ? data.staff : false);
    form.controls.title.setValue(data.title ? data.title : "");
    form.controls.tester.setValue(data.tester ? data.tester : false);
    form.controls.zzversion.setValue(data.zzversion ? data.zzversion : "0");

    form.controls.resident_institute.setValue(data.resident_institute);

    // console.log("resident_institute: " + data.resident_institute)
    // console.log("resident_institute: " + form.controls.resident_institute.value)

    form.controls.proofOfVaccine.setValue(data.proofOfVaccine);

    let dtBegin
    if (data.resident_begin) {
      dtBegin = new Date(data.resident_begin.seconds * 1000)
    }
    form.controls.resident_begin.setValue(dtBegin);

    let dtEnd
    if (data.resident_end) {
      dtEnd = new Date(data.resident_end.seconds * 1000)
    }
    form.controls.resident_end.setValue(dtEnd);

    // console.log("data.image: " + data.image )

    this._gn1Service.storedImage = data.image;
  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      category: new FormControl(''),
      //    subCategory_id: new FormControl('', [Validators.required]),
      situation: new FormControl('', [ Validators.required ]),
      balance: new FormControl(''),
      credit: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      image: new FormControl(''),
      text: new FormControl(''),
      text_html: new FormControl(''),
      address: new FormControl(''),
      number: new FormControl(''),
      complement: new FormControl(''),
      postalCode: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      country: new FormControl(''),
      email: new FormControl('', [ Validators.required, Validators.email ]),
      email2: new FormControl(''),
      cellPhonePrefix: new FormControl(''),
      cellPhone: new FormControl('', [ Validators.required ]),
      faxPhone: new FormControl(''),
      clinicPhone: new FormControl(''),
      hospitalPhone: new FormControl(''),
      aux1Phone: new FormControl(''),
      aux2Phone: new FormControl(''),
      rg: new FormControl(''),
      // cpf: new FormControl('', [Validators.required, cpfValidator]),
      cpf: new FormControl(''),
      crm: new FormControl(''),
      dateBirth: new FormControl(''),
      dateFiliation: new FormControl(''),
      dateTitle: new FormControl(''),
      dateCreated: new FormControl(''),
      regional: new FormControl(''),
      sex: new FormControl(''),
      obs: new FormControl(''),
      staff: new FormControl(''),
      tester: new FormControl(''),
      zzversion: new FormControl(''),
      title: new FormControl(''),

      resident_institute: new FormControl(''),
      resident_begin: new FormControl(''),
      resident_end: new FormControl(''),

      proofOfVaccine: new FormControl('')

    });
    return form
  }



  formatDate (date: Date) {
    if (date) {
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }


}



